/**
 * Human-readable message from axios/API errors (ASP.NET BadRequest `{ message }`, ProblemDetails `{ title, detail }`, etc.).
 * @param {unknown} error
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback = 'Request failed') {
  const msgLower = String(error?.message || '').toLowerCase();
  const isTimeout =
    error?.code === 'ECONNABORTED' || msgLower.includes('timeout') || msgLower.includes('timed out');
  if (isTimeout && !error?.response) {
    return (
      'Request timed out. The server talks to your Besu JSON-RPC for this action (nonce, gas, estimateGas). ' +
      'Start Besu or fix Besu:ObserverRpcHttpUrl in appsettings, or wait if the node is very slow. ' +
      'The app now allows up to 2 minutes for these calls.'
    );
  }

  const d = error?.response?.data;
  if (d == null || d === '') {
    return error?.message || fallback;
  }
  if (typeof d === 'string') {
    return d.trim() || fallback;
  }
  const msg = d.message ?? d.Message ?? d.detail ?? d.Detail;
  if (msg != null && String(msg).trim()) {
    return String(msg).trim();
  }
  const title = d.title ?? d.Title;
  if (title != null && String(title).trim()) {
    return String(title).trim();
  }
  const errors = d.errors ?? d.Errors;
  if (errors && typeof errors === 'object') {
    const first = Object.values(errors).flat?.()[0] ?? Object.values(errors)[0];
    if (Array.isArray(first) && first[0]) return String(first[0]);
    if (typeof first === 'string') return first;
  }
  return error?.message || fallback;
}
